"use strict";
(() => {
  function disableQty() {
    document
      .querySelectorAll(".cart-item-list__body .cart-item")
      .forEach((row) => {
        // Find the product with the name 'Almond Milk Concentrate Eco-Refill'
        const productName = row.querySelector(".cart-item__title");
        if (
          productName &&
          productName.textContent.trim() ===
            "[NOT FOR SALE] Limited Edition Red Packet 2025"
        ) {
          console.log("disableQty Init");
          // Disable the increment and decrement buttons
          const decrementBtn = row.querySelector(
            ".quantity.buttoned-input .quantity-down",
          );
          const incrementBtn = row.querySelector(
            ".quantity.buttoned-input .quantity-up",
          );
          const removeBtn = row.querySelector(".cart-item__remove");

          decrementBtn.style.display = "none";
          incrementBtn.style.display = "none";
          removeBtn.style.display = "none";

          console.log(decrementBtn, incrementBtn);

          const qtyInput = row.querySelector(".cart-item__quantity-input");

          if (decrementBtn) {
            decrementBtn.setAttribute("disabled", "true");
          }
          if (incrementBtn) {
            incrementBtn.setAttribute("disabled", "true");
          }
          if (qtyInput) {
            qtyInput.setAttribute("disabled", "true");
          }

          // Append the custom text under the product title
          const customMessage = document.createElement("p");
          customMessage.textContent = "Only Entitled One Pack Per Order.";
          customMessage.style.fontSize = "11px";
          customMessage.style.color = "#AF4D23";
          customMessage.style.fontWeight = "bold";

          // Insert the message after the title
          productName.parentElement.appendChild(customMessage);
        }
      });
  }

  function onDomContentLoaded() {
    disableQty();

    console.log("Fox Here");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDomContentLoaded, {
      once: true,
    });
  } else {
    onDomContentLoaded();
  }
})();
